import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faUserAlt } from "@fortawesome/free-solid-svg-icons";

const MenuGuest = ({ menuActive }) => {
  const navigate = useNavigate();

  const menus = [
    {
      key: "register",
      label: "สมัครสมาชิก",
      icon: faUserAlt,
      path: "/register",
    },
    {
      key: "login",
      label: "เข้าสู่ระบบ",
      icon: faLock,
      path: "/login",
    },
  ];

  const buttonClass = (key) =>
    `lg:hidden xl:w-auto flex items-center justify-center w-[190px] px-5 py-2 text-nowrap text-base rounded-[25px] cursor-pointer
     ${
       menuActive === key
         ? "text-white bg-[#43A1EF]"
         : "text-black bg-white border border-[#5E5E5E]"
     }`;

  return (
    <div className="xl:gap-[20px] flex h-[80px] p-2 items-center gap-[20px]">
      {menus.map((menu) => (
        <div
          key={menu.key}
          className={buttonClass(menu.key)}
          onClick={() => navigate(menu.path)}
        >
          <FontAwesomeIcon icon={menu.icon} className="w-4 h-4 mr-[10px]" />
          {menu.label}
        </div>
      ))}
    </div>
  );
};

export default MenuGuest;
